import { ReactNode } from "react";

import styled from "styled-components";

import { BaseProps } from "../../BaseProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { DarkGrey, toString } from "../Color";
import { Tooltip } from "../Tooltip";

/** The `Callout` component properties. */
export interface CalloutProps extends BaseProps {
  /** The tooltip text. */
  readonly tooltip: ReactNode;

  /** The tabIndex for the callout trigger element. If not provided, defaults to 0 to make it keyboard-focusable. */
  readonly tabIndex?: number;

  /** The component children. */
  readonly children?: ReactNode;
}

const StyledCallout = styled.span`
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 24%;
  text-decoration-thickness: 10%;
  text-decoration-skip-ink: none;
  text-decoration-color: ${toString(DarkGrey[500])};
  cursor: help;
`;

/** A component which wraps a set of inline content with a tooltip. */
export const Callout = (props: CalloutProps) => {
  const { tooltip, tabIndex, children } = props;

  const htmlProps = getHtmlPropsFromBaseProps(props, {
    className: "callout",
  });

  return (
    <Tooltip content={tooltip}>
      {(ref) => (
        <StyledCallout {...htmlProps} ref={ref} tabIndex={tabIndex ?? 0}>
          {children}
        </StyledCallout>
      )}
    </Tooltip>
  );
};
